const breadcrumbToggle = document.querySelector( '[data-action="toggleBreadcrumb"]' );
const breadcrumbToggleMobile = document.querySelector( '[data-action="toggleBreadcrumbMobile"]' );
const breadcrumb = document.getElementById( 'mobile-breadcrumb' );

if ( breadcrumbToggle ) {
	breadcrumbToggle.addEventListener( 'click', ( e ) => {
		breadcrumbToggle.classList.toggle( '-rotate-180' );
		breadcrumbToggle.classList.toggle( 'text-identity-blue' );
		breadcrumbToggle.classList.toggle( 'dark:text-identity-yellow' );
		breadcrumb.classList.toggle( 'hidden' );
	} );
}

if ( breadcrumbToggleMobile ) {
	breadcrumbToggleMobile.addEventListener( 'click', ( e ) => {
		breadcrumbToggle.classList.toggle( 'text-identity-blue' );
		breadcrumbToggle.classList.toggle( 'dark:text-identity-yellow' );
		breadcrumb.classList.toggle( 'hidden' );
	} );
}
